import { useEffect, useState } from "react";

const ABTest = () => {
    const [whichAB, setWhichAB] = useState(null);

    const link = {
        A: "https://ettarracoffee.com",
        B: "https://innovation.ettarracoffee.com"
    };

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const which = params.get("which");

        if (which === "A" || which === "B") {
            setWhichAB(which);
        } else {
            const random = Math.random() < 0.5 ? "A" : "B";
            setWhichAB(random);
        }
    }, []);

    if (!whichAB) return null; // avoid flicker

    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center', width: '100vw', height: '100vh' }}>

            {/* IFRAME */}
            <iframe
                src={link[whichAB]}
                frameBorder="0"
                style={{ width: '100vw', height: '90vh' }}
                title="Menu"
            />

            <div style={{ position: 'absolute', bottom: '12vh', display: 'flex', width: 'fit-content', height: 'fit-content', padding: '5px 15px', fontSize: '0.75rem', fontWeight: 900, textAlign: 'center', borderRadius: '25px', backgroundColor: '#FFF', boxShadow: '0px 0px 15px #001E3A99', zIndex: 1000 }}>Showing {whichAB}</div>

            {/* TOGGLE BAR */}
            <div style={{ display: 'flex', width: '100vw', height: '10vh' }}>

                {/* A */}
                <div
                    onClick={() => setWhichAB('A')}
                    style={{
                        width: '40vw',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: '#FFF',
                        boxShadow: whichAB === 'A'
                            ? "inset 0px 0px 15px #001E3A50, inset 0px 0px 25px #001E3A50"
                            : '',
                        fontSize: '1.75rem',
                        fontWeight: 900
                    }}
                >
                    A
                </div>

                {/* HOME */}
                <a
                    href="https://samudaya.ettarracoffee.com"
                    style={{
                        width: '20vw',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: '#FFF'
                    }}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#001E3A"><path d="M240-200h120v-240h240v240h120v-360L480-740 240-560v360Zm-80 80v-480l320-240 320 240v480H520v-240h-80v240H160Zm320-350Z" /></svg>
                </a>

                {/* B */}
                <div
                    onClick={() => setWhichAB('B')}
                    style={{
                        width: '40vw',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: '#FFF',
                        boxShadow: whichAB === 'B'
                            ? "inset 0px 0px 15px #001E3A50, inset 0px 0px 25px #001E3A50"
                            : '',
                        fontSize: '1.75rem',
                        fontWeight: 900
                    }}
                >
                    B
                </div>

            </div>
        </div>
    );
};

export default ABTest;